<template>
  <div>
    <div style="background: #E6A23C; opacity: 0.7 ; text-align: center; padding: 6px">
      ตั้งแต่วันที่ 13 สิงหาคม 2567 เป็นต้นไป ผู้ใช้งานระบบจำเป็นต้องตั้งค่าการยืนยันตัวตนแบบ 2 ขั้นตอน (2FA) <br/> เพื่อเพิ่มความปลอดภัยแก่บัญชีผู้ใช้งานได้มากยิ่งขึ้น และลดความเสี่ยงจากการถูกโจมตีจากอาชญากรรมไซเบอร์ให้น้อยลง
    </div>
  <div class="login-box">
    <form @submit="onSubmitLoginForm">
      <div style="text-align: center;">
        <div style="margin-bottom: 30px">
          <img style="width: 80%" alt="Contract Manager logo" src="../assets/contract-login-logo.png">
        </div>
        <div class="input">
          <label class="login-input">Company Code</label>
          <el-input placeholder="Company Code" name="txtCode" v-model="companyCode" class="company-code"></el-input>
        </div>
        <div class="input">
          <label class="login-input">Username</label>
          <el-input placeholder="Username" name="txtUsername" v-model="username"></el-input>
        </div>
        <div class="input">
          <label class="login-input">Password</label>
          <el-input type="password" placeholder="Password" name="txtPassword" v-model="password" autocomplete="off"></el-input>
        </div>
        <div v-if="isRequireOtp" class="input">
          <label class="login-input">OTP</label>
          <el-input name="otp"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')"
                    v-model.number="otp"
                    autocomplete="off"
                    maxlength="6"
          ></el-input>

        </div>
        <div>
          <el-button v-if="!isRequireOtp" type="primary" name="btnLogin" native-type="submit">Log In</el-button>
          <el-button v-else type="primary" name="verifyOtp" @click="onVerifyOtpButtonClick()">Verify</el-button>
        </div>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
import LoginService from '@/services/login-service'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'

export default {
  name: 'Login',
  mixins: [AlertViewMixin, LoadingViewMixin],
  data () {
    return {
      companyCode: '',
      username: '',
      password: '',
      otp: '',
      isRequireOtp: false
    }
  },
  methods: {
    onSubmitLoginForm: async function (event) {
      event.preventDefault()

      try {
        this.startLoading()

        const isRequireOtp = await LoginService.checkRequireOtp(this.username)

        if (isRequireOtp) {
          this.isRequireOtp = isRequireOtp
          this.stopLoading()
          return
        }

        await LoginService.login(this.companyCode, this.username, this.password, this.otp)
        await this.onLoginSuccess()
      } catch (err) {
        if (err.status === 302) {
          const msg = this._prepareHtmlMessageForSet2fa(err)
          this.alertErrorWithHtml(msg)
        } else {
          this.alertError(err.message)
        }
      }

      this.stopLoading()
    },
    onVerifyOtpButtonClick: async function (event) {
      try {
        this.startLoading()
        await LoginService.login(this.companyCode, this.username, this.password, this.otp)
        await this.onLoginSuccess()
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onLoginSuccess: async function () {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)
      this.$router.push({
        name: routeName
      })
    },
    _prepareHtmlMessageForSet2fa: function (res) {
      const html = '<div>คุณยังไม่ได้ตั้งค่า 2FA </div>' +
        '<div> กรุณาตั้งค่า 2FA ก่อนใช้งาน</div>' +
        `<a style="text-align: center" href="${res.url}" target="_blank">ตั้งค่า 2FA</a>`

      return html
    }
  }
}
</script>

<style>
  form .input {
    text-align: left;
    margin-bottom: 20px;
  }
  form .company-code.el-input input{
    text-transform: uppercase;
  }

  .login-input {
    position: relative;
    bottom: 5px;
    font-size: 15px;
    font-weight: 500;
  }
  .login-box {
    width: 350px;
    min-height: 300px;
    position: fixed;
    top: 35%;
    left: 50%;
    margin-top: -150px;
    margin-left: -200px;
    background-color: #fff;
    border-radius: 6px;
    padding: 25px;
    -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    -ms-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    -o-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
</style>
